import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import fb from "../Assets/facebook.svg";
import ig from "../Assets/instagram.svg";
import linked from "../Assets/linkedin.svg";

import logo from "../Assets/command-line.png";
import { Link } from "react-router-dom";

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <Row>
          <Col md={3} className="mobPadding">
            <Link to="/">
              <img
                src={logo}
                className="d-inline-block align-top logoIconFooter"
                alt="Compile Labs Logo - Mobile/Web Design and Development"
              />
            </Link>
          </Col>
          <Col md={3} className="mobPadding">
            <h4 style={{ fontWeight: "900" }}>Contact Us</h4>
            <div style={{ margin: "20px 0", lineHeight: "30px" }}>
              brandon.r.caiza@gmail.com
              <br /> <br />
              Vancouver, BC, Canada
              <br />
              <br />
              Kelowna, BC, Canada
              <br />
              <br />
              + 1 250 212 3073
              <br />
            </div>
          </Col>

          <Col md={3} className="mobPadding">
            <h4 style={{ fontWeight: "900" }}>Social</h4>
            <Row style={{ marginTop: "30px" }}>
              <Col md={2} sm={4} className="iconMarge">
                <a href="https://www.facebook.com/compileLabs" target="_blank">
                  <img src={fb} className="socialIcons" />
                </a>
              </Col>
              <Col md={2} sm={4} className="iconMarge">
                <a href="https://www.instagram.com/compilelabs" target="_blank">
                  <img src={ig} className="socialIcons" />
                </a>
              </Col>
              <Col md={2} sm={4} className="iconMarge">
                <a
                  href="https://www.linkedin.com/in/brandon-caiza-4b8a3918b/"
                  target="_blank"
                >
                  <img src={linked} className="socialIcons" />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;
